import React from 'react';
import Icon from '../../../components/AppIcon';

const PlannerSpecifications = ({ specifications }) => {
  const specItems = [
    {
      label: 'Planner Type',
      value: specifications?.type,
      icon: 'Calendar'
    },
    {
      label: 'Layout Style',
      value: specifications?.layout,
      icon: 'Layout'
    },
    {
      label: 'Color Theme',
      value: specifications?.colorTheme,
      icon: 'Palette'
    },
    {
      label: 'Start Date',
      value: specifications?.startDate,
      icon: 'CalendarDays'
    },
    {
      label: 'Duration',
      value: specifications?.duration,
      icon: 'Clock'
    },
    {
      label: 'Page Size',
      value: specifications?.pageSize,
      icon: 'FileText'
    },
    {
      label: 'Sections Included',
      value: specifications?.sections?.join(', '),
      icon: 'List'
    },
    {
      label: 'Custom Features',
      value: specifications?.customFeatures?.join(', '),
      icon: 'Settings'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Info" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-semibold text-foreground">
            Planner Specifications
          </h2>
          <p className="font-body text-sm text-muted-foreground">
            Your customization summary
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {specItems?.map((item, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-200">
            <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={item?.icon} size={14} className="text-muted-foreground" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-body font-medium text-sm text-foreground mb-1">
                {item?.label}
              </div>
              <div className="font-body text-sm text-muted-foreground break-words">
                {item?.value}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Reorder Button */}
      <div className="mt-6 pt-6 border-t border-border">
        <button className="w-full bg-secondary/10 text-secondary border border-secondary/20 px-4 py-3 rounded-lg font-body font-medium hover:bg-secondary/20 transition-colors duration-200 flex items-center justify-center space-x-2">
          <Icon name="RotateCcw" size={16} />
          <span>Create Similar Planner</span>
        </button>
      </div>
    </div>
  );
};

export default PlannerSpecifications;